import { createEnvelopeSource } from './create-envelope-source';
import { DOC31_EDITION_ID } from './doc31-edition';

/**
 * Players of one 31DOC edition (`GET /analytics/players-31doc`): active players
 * over the period, its last 7 days and its last day, players who enrolled, and
 * the repeat visit rate. Read off the edition's own participations, in their
 * province snapshot.
 */
export const players31docSource = createEnvelopeSource({
    label: '31DOC players',
    endpoint: 'analytics/players-31doc',
    metrics: [
        {
            id: 'activeUsers31doc',
            label: '31DOC active players',
            type: 'scalar',
        },
        {
            id: 'weeklyActiveUsers31doc',
            label: 'Weekly active players',
            type: 'scalar',
        },
        {
            id: 'dailyActiveUsers31doc',
            label: 'Daily active players',
            type: 'scalar',
        },
        { id: 'newPlayers31doc', label: 'New players', type: 'scalar' },
        {
            id: 'repeatVisitRate31doc',
            label: 'Repeat visit rate',
            type: 'ratio',
        },
    ],
    forms: ['number', 'rate'],
    regionGrain: 'province',
    staticParams: { campaignId: DOC31_EDITION_ID },
});
